/* import __COLOCATED_TEMPLATE__ from './brand-phone-dropdown-item.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import templateOnlyComponent from '@ember/component/template-only';

interface BrandPhoneDropdownItemSignature {
  Args: {
    item: {
      text: string;
      value: string;
      isSelected: boolean;
      componentAttrs: {
        formattedNumber: string;
        hasName: boolean;
        isCalling: boolean;
        isSms: boolean;
        callingTooltip: string;
        smsTooltip: string;
      };
    };
    selectItem: (item: any) => void;
  };
  Element: HTMLElement;
}

const BrandPhoneDropdownItem = templateOnlyComponent<BrandPhoneDropdownItemSignature>();
export default BrandPhoneDropdownItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Brands::BrandPhoneDropdownItem': typeof BrandPhoneDropdownItem;
    'new-settings/workspace/brands/brand-phone-dropdown-item': typeof BrandPhoneDropdownItem;
  }
}
